<table class="table table-striped table-borderless">
  <tr>
    <th style="width:150px">Sub Transaction</th>
    <th style="width:150px">Status</th>
    <th style="width:450px">Description</th>
    <th>Start Date</th>
    <th>End Date</th>
    <th *ngIf="!isSupportUser">Actions</th>
  </tr>

  <tr *ngFor="let st of transactionLog?.subTransactions">
    <td>{{st.productName}}</td>
    <td><span class="mr-2 {{getStatusIconClassName(st.statusName)}}"></span><span class="{{getStatusTextClassName(st.statusName)}}">{{st.statusName}}</span></td>
    <td>
      <span *ngIf="isFailedStatus(st)">
          <span>{{  st.truncateErrorDescription}} </span>
          <a href="javascript:void(0)" *ngIf="st.truncateErrorDescription.endsWith('...')" (click)="showMore(st)">Show more</a>
      </span>
      <span *ngIf="!isFailedStatus(st) && st.productName === 'MESSAGE_BUS'">
          {{st.statusDescription}}
      </span>
    </td>
    <td>{{longDateFormat(st.startDate)}}</td>
    <td><span [class.in-progress]="!st.endDate">{{longDateFormat(st.endDate)||'In Progress'}}</span></td>
    <td *ngIf="!isSupportUser"><a *ngIf="isFailedStatus(st)" href="javascript:void(0)" (click)="resolve(st.subTransactionId)">Mark as Resolved</a></td>
  </tr>

</table>
